import "./CodeLine.scss";
interface CodeLineProps {
  lineNumber: number;
  words?: Array<any>;
}
const CodeLine: React.FC<CodeLineProps> = ({ lineNumber, words }) => {
  return (
    <div className="code-line-layout">
      <div className="code-line-layout__line-number">{lineNumber}</div>
      {words?.map((word, idx) => (
        <div key={idx} className={`code-line-layout__${word.class}`}>
          {word.text}
          {word.list?.map((l: any, idx: number) => (
            <div className={`code-line-layout__${l.class}`} key={idx}>
              {l.text}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};
export default CodeLine;
